import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-input-fields',
  templateUrl: './input-fields.component.html',
  styleUrls: ['./input-fields.component.scss']
})
export class InputFieldsComponent implements OnInit{

  type: string = 'text';
  placeholder: string = '';
  value: string = '';
  label: string = '';
  noOfFields: number = 1;
  multipleFields: boolean = false;
  isRequired: boolean = false;
  isNewRow = false;

  constructor() { }

  ngOnInit(): void {
    
  }

}
